const AUTOCOMPLETE_MAX_RESULTS = 20;
export default [
    'LogService', 'WebClientService',
    function (logService, webClientService) {
        const log = logService.getLogger('MemberListEditor-C');
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                members: '=activeMembers',
                onChange: '=onChange',
                placeholder: '=placeholder',
            },
            controllerAs: 'ctrl',
            controller: [function () {
                    this.selectedItemChange = (contactReceiver) => {
                        if (contactReceiver !== undefined) {
                            this.members.push(contactReceiver.id);
                            this.selectedItem = null;
                            this.onChange(this.members);
                        }
                    };
                    this.querySearch = (query) => {
                        if (query !== undefined && query.length <= 0) {
                            return [];
                        }
                        else {
                            const lowercaseQuery = query.toLowerCase();
                            const hideInactiveAndRevokedContacts = !webClientService.appConfig.showInactiveIDs;
                            const result = this.allContacts
                                .filter((contactReceiver) => {
                                if (this.members.filter((id) => id === contactReceiver.id).length !== 0) {
                                    return false;
                                }
                                if (contactReceiver.id === webClientService.me.id) {
                                    return false;
                                }
                                if (hideInactiveAndRevokedContacts && contactReceiver.state === 'INACTIVE') {
                                    return false;
                                }
                                if (hideInactiveAndRevokedContacts && contactReceiver.state === 'INVALID') {
                                    return false;
                                }
                                if (contactReceiver.displayName.toLowerCase().indexOf(lowercaseQuery) >= 0) {
                                    return true;
                                }
                                if (contactReceiver.id.toLowerCase().indexOf(lowercaseQuery) >= 0) {
                                    return true;
                                }
                                return false;
                            });
                            return result.length <= AUTOCOMPLETE_MAX_RESULTS ? result
                                : result.slice(0, AUTOCOMPLETE_MAX_RESULTS);
                        }
                    };
                    this.onRemoveMember = (contact) => {
                        if (contact.id === webClientService.me.id) {
                            return false;
                        }
                        this.members = this.members.filter((identity) => identity !== contact.id);
                        return true;
                    };
                    this.$onInit = function () {
                        this.allContacts = Array.from(webClientService.contacts.values());
                    };
                }],
            template: `
                <ul class="member-list">
                    <li>
                        <md-autocomplete
                                md-no-cache="false"
                                md-delay="200"
                                md-selected-item="ctrl.selectedItem"
                                md-search-text="ctrl.searchText"
                                md-selected-item-change="ctrl.selectedItemChange(contactReceiver)"
                                md-items="contactReceiver in ctrl.querySearch(ctrl.searchText)"
                                md-item-text="contactReceiver.displayName"
                                md-min-length="0"
                                placeholder="{{ctrl.placeholder}}"
                                md-menu-class="autocomplete-custom-template">
                            <md-item-template>
                                <eee-contact-badge
                                        eee-contact="contactReceiver"
                                        eee-disable-click="true"/>
                            </md-item-template>
                        </md-autocomplete>
                    </li>
                    <li ng-repeat="identity in ctrl.members">
                        <eee-contact-badge
                                eee-identity="identity"
                                eee-disable-click="true"
                                eee-on-remove="ctrl.onRemoveMember"/>
                    </li>
                </ul>
            `,
        };
    },
];
